/*import { createStore } from 'redux'

const initialState = {
  sidebarShow: true,
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    default:
      return state
  }
}

const store = createStore(changeState)
export default store
*/


import logger from 'redux-logger'
import { createStore, applyMiddleware, combineReducers, compose} from 'redux';
import createSagaMiddleware from 'redux-saga';
import storage from 'redux-persist/lib/storage'
import { persistStore, persistReducer } from 'redux-persist';

import rootReducer from './reducers/index';
import rootSaga from './utils/saga';

const sagaMiddleware = createSagaMiddleware();



const persistConfig = {
  key: 'root',
  storage,
};


const initialState = {
  sidebarShow: true,
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    default:
      return state
  }
}




const persistedReducer = persistReducer(persistConfig, rootReducer);


const store = createStore(
  persistedReducer,
  applyMiddleware(sagaMiddleware, logger),
);



sagaMiddleware.run(rootSaga);

export default store;
export const persistor = persistStore(store);

//new from 01.05.26 for integration assetmanager

// ─── Selectors ────────────────────────────────────────────────────────────────

export const selectAllAssets = (s) => s.assets.items;
export const selectFilters = (s) => s.assets.filters;

export const selectAssetById = (state, id) =>
  state.assets.items.find((a) => a.id === id);

export const selectFilteredAssets = (state) => {
  const { items, filters } = state.assets;
  const q = (filters.search || '').toLowerCase();
  return items.filter((a) => {
    if (filters.category && a.category !== filters.category) return false;
    if (filters.state && a.state !== filters.state) return false;
    if (filters.locationId && a.locationId !== filters.locationId) return false;
    if (q) {
      const hit =
        a.name.toLowerCase().includes(q) ||
        (a.inventoryNumber || '').toLowerCase().includes(q) ||
        (a.serialNumber || '').toLowerCase().includes(q) ||
        (a.assignedTo || '').toLowerCase().includes(q) ||
        (a.subtype || '').toLowerCase().includes(q);
      if (!hit) return false;
    }
    return true;
  });
};

export const selectDashboardStats = (state) => {
  const items = state.assets.items;
  const today = new Date();
  const byState = {};
  const byCategory = {};
  let totalValue = 0;
  const overdue = [];
  const upcoming = [];
  items.forEach((a) => {
    byState[a.state] = (byState[a.state] || 0) + 1;
    byCategory[a.category] = (byCategory[a.category] || 0) + 1;
    totalValue += Number(a.value) || 0;
    if (a.nextMaintenance) {
      const d = Math.ceil((new Date(a.nextMaintenance) - today) / 86400000);
      if (d < 0) overdue.push({ ...a, daysOverdue: Math.abs(d) });
      else if (d <= 30) upcoming.push({ ...a, daysLeft: d });
    }
  });
  return {
    total: items.length,
    byState,
    byCategory,
    totalValue,
    overdue: overdue.sort((a, b) => b.daysOverdue - a.daysOverdue),
    upcoming: upcoming.sort((a, b) => a.daysLeft - b.daysLeft),
    pendingSync: items.filter((a) => a.syncStatus === 'pending').length,
  };
};

export const selectAllLocations = (s) => s.locations.items;
export const selectActiveLocations = (s) =>
  s.locations.items.filter((l) => l.active !== false);

export const selectActiveTab = (s) => s.ui.activeTab;
export const selectView = (s) => s.ui.view;
export const selectViewPayload = (s) => s.ui.viewPayload;
export const selectNotifications = (s) => s.ui.notifications;
export const selectActiveModal = (s) => s.ui.activeModal;
export const selectModalPayload = (s) => s.ui.modalPayload;
export const selectSidebarShow = (s) => s.core.sidebarShow;

// ─── Re-export actions ────────────────────────────────────────────────────────
export {
  addAsset,
  updateAsset,
  deleteAsset,
  addMaintenanceEntry,
  deleteMaintenanceEntry,
  setFilter,
  clearFilters,
  markSynced,
  applyServerUpdate,
  markSyncError,
  resetToDefaults,
} from '../src/views/DigitalAssets/assetsSlice';

export { addLocation, updateLocation, deleteLocation } from '../src/views/DigitalAssets/locationsSlice';

export {
  navigateTo,
  setView,
  goBack,
  pushNotification,
  dismissNotification,
  openModal,
  closeModal,
} from '../src/views/DigitalAssets/uiSlice';